import {
  INICIALITZAR,
  INDIVIDU_INICIALITZAR,
  OBTENIR_DADES_INDIVIDU,
  ESBORRAR_INDIVIDU_SELECCIONAT
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = {
  id: null,
  altitud: null,
  dataBaixa: null,
  descripcio: null,
  latitud: null,
  longitud: null,
  motiuBaixa: null,
  nomCientific: null,
  idIndividuVegetal: null,
  idIndret: null,
  nomIndret: null,
  idObservador: null,
  nomObservador: null,
  fenofases: null,
  idEspecie: null,
  nomEspecie: null,
  idSubespecie: null,
  nomSubespecie: null,
  idVarietat: null,
  nomVarietat: null,
  idGenere: null,
  nomGenere: null,
  idCollectiu: null,
  nomCollectiu: null,
  idClasse: null,
  nomClasse: null,
  idRegne: null,
  nomRegne: null,
  indretIndividuDataAlta: null,
  canvis: null,
  solana: null,
  plantada: null,
  fertilitzat: null,
  reg: null,
  genotip: null
};

const originals = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDIVIDU_INICIALITZAR:
    case INICIALITZAR:
    case `${OBTENIR_DADES_INDIVIDU}_EN_CURS`:
    case `${OBTENIR_DADES_INDIVIDU}_ERROR`:
    case ESBORRAR_INDIVIDU_SELECCIONAT:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_INDIVIDU}_SUCCESS`:
      return action.payload.individu;

    default:
      return state;
  }
};

export default originals;
